export default __webpack_public_path__ + "static/media/calculator-moneystack3.07346bf5.png";